import React, { useContext, useEffect } from "react"
import { useTranslation } from "react-i18next";

import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import Tooltip from "@mui/material/Tooltip";

import { IButtonConfig, ICustomButtonGroupProps } from "@/@types/ui/CustomButtonGroup";

function CustomButtonGroup(props: ICustomButtonGroupProps) {
	const { t } = useTranslation();

	const { buttonConfig, handleClick, verySmall, selectedButtons, ...rest } = props;

	return (
		<ButtonGroup {...rest}>
			{
				buttonConfig.map((btn: IButtonConfig, i: number) => (
					<Tooltip key={i} title={!rest.disabled && btn.ttip ? <>{t(btn.ttip)}</> : ''}>
						<Button
							style={verySmall ? {
								minWidth: 0,
								fontSize: "0.6rem",
								fontWeight: 900,
								padding: "2px 5px",
							} : {}}
							onClick={() => handleClick(btn)}
							variant={selectedButtons && selectedButtons[i] ? "contained" : "outlined"}
						>
							{t(btn.label)}
						</Button>
					</Tooltip>
				))
			}
		</ButtonGroup>
	);
}

export default CustomButtonGroup;